<template>
<w-app id="app">
  <z-header />

  <w-flex grow class="zcontainer" >

    <z-sidebar />

    <main class="grow" :class="bgColor">

      <div class="title2 mt3">
        {{ title }}
      </div>

      <w-flex align-left>

      <div class="box mr2">
        <w-icon md class="color-main-theme mt1">fal fa-home</w-icon>
      </div>

      <div class="box mb5 mt1">
        <w-breadcrumbs :items="crumbs">
          <template #separator>\</template>
        </w-breadcrumbs>
      </div>

      </w-flex>


      <w-transition-bounce>

        <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.success"
          success
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{$page.props.flash.success}}
        </w-alert>
        </w-transition-bounce>
        <w-transition-bounce>

        <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.error"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{$page.props.flash.error}}
        </w-alert>
      </w-transition-bounce>

      <w-notification
        v-if="$page.props.flash.notify"
        success
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notify = ''"
        >
        {{$page.props.flash.notify}}
      </w-notification>

      <w-notification
        v-if="$page.props.flash.notifyerror"
        error
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notifyerror = ''"
        >
        {{$page.props.flash.notifyerror}}
      </w-notification>



      <!-- <w-divider class="my1 mb3"></w-divider> -->
<!--
      <w-card class="welcomeuserinfo mb3" v-if="showuserinfo">
        <w-flex justify-start class="text-left">
            <div class="box">
            <w-image
              class="sh1 bdrsr d-block"
              :src="$page.props.auth.user.avatar"
              :width="72"
              :height="72">
            </w-image>
            </div> -->

          <!-- <div class="box ml2">
              <h4 class="mt3">Selamat Datang {{ $page.props.auth.user.name }} </h4>
              <span class="">Log masuk terakhir anda adalah pada </span>
              <span class="box-date">{{ $zutil.dateformat($page.props.auth.user.updated_at) }} </span>
          </div> -->

        <!-- </w-flex>
      </w-card> -->

      <slot />

    </main>
  </w-flex>

  <z-footer />
</w-app>
</template>

<script>

import zHeader from '@/Shared/Layout/Header'
import zSidebar from '@/Shared/Layout/Sidebar'
import zFooter from '@/Shared/Layout/Footer'

export default {
components: {
  zHeader,
  zSidebar,
  zFooter
},
props: {
  title: {
    type: String,
    default: 'Welcome to zTemplate'
  },
  showuserinfo: {
    type: Boolean,
    default: true
  },
  bgColor: {
    type: String,
    default: 'main--bg'
  },
  crumbs: {
    type: Array,
    default: [
        { label: 'Home', route: '/' },
      ],
  }
},
data: () => ({
}),
methods: {

}
}

</script>

<style>

.w-app {
  padding: 0px;
  background: radial-gradient(farthest-side ellipse at 10% 0,#333867,#17193b);
}

aside, main {
  margin: 0px;
  padding: 12px;
}

.zcontainer {
  margin-top: 55px;
}

.welcomeuserinfo {
  border-radius: 3px;
}

.welcomeuserinfo:before {
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  /* background-image: url('/images/zen.jpeg'); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.box h4 {
    font-weight: 500;
    font-size: 20px;
}
</style>
